import styled, { css } from 'styled-components';
import { Checkbox } from 'antd';

export const StyledCheckBox = styled(Checkbox)`
    ${({ theme }) => css`
        .ant-checkbox-checked .ant-checkbox-inner {
            background-color: ${theme.colors.accentColor};
            border-color: ${theme.colors.accentColor};
        }
    `}
`;

export const Title = styled.p`
    ${({ theme }) => css`
        color: ${theme.colors.font};
        font-size: ${theme.fontSizes.little};
        margin: 0px;
    `}
`;
